import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "category__product-list media-with-products"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "media-with-products__overlay-container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "media-with-products__overlay-container" }
const _hoisted_7 = ["innerHTML"]

import ProductCard from '@/components/ProductCard';
import { inject, onMounted, onUnmounted, ref } from 'vue'
import { registerListingBlockKey, unregisterListingBlockKey } from '@/composables/useDynamicProductListing'
import { computed } from 'vue';
import { clamp } from '@/utils';
import useBanners from '@/composables/useBanners';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaWithProducts',
  props: {
  block: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props



const products = ref<any>([]);
const registerListingBlock = inject(registerListingBlockKey, () => { });
const unregisterListingBlock = inject(unregisterListingBlockKey, () => { });

const numberOfProducts = computed(() => clamp(props.block?.fields?.NumberOfProducts || 0, 2));

const { banners } = useBanners(props.block.fields.Banners, 'media-with-products');
const mainBanner = computed(() => banners.value?.[0]);
const secondaryBanner = computed(() => {
  if (products.value.length > 1) return null;
  return banners.value?.[1];
});

const numberOfBanners = computed(() => {
  return [mainBanner.value, secondaryBanner.value]
    .filter(b => b)
    .length;
});

const bannerContainerClasses = computed(() => {
  const classes = [
    'media-with-products__banners-container',
    `media-with-products__banners-container--${numberOfBanners.value}`,
    `media-with-products__banners-container--products${products.value.length}`,
  ];

  if (shouldReverseRendering.value) {
    classes.push('media-with-products__banners-container--reverse');
  }

  return classes;
});

const shouldReverseRendering = computed(() => props.block?.fields?.Reverse || false);

onMounted(async () => {
  await registerListingBlock(props.block.systemId, {
    setProducts,
    numProducts: numberOfProducts.value,
  });
});

onUnmounted(() => {
  unregisterListingBlock(props.block.systemId);
});

function setProducts(parentProducts: [any]) {
  products.value = parentProducts;
}

const shouldRender = computed(() => products.value.length > 0 && numberOfBanners.value);


return (_ctx: any,_cache: any) => {
  return (_unref(shouldRender))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(bannerContainerClasses))
        }, [
          (_unref(mainBanner))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(mainBanner).element), {
                key: 0,
                to: _unref(mainBanner).link,
                class: "media-with-products__banner media-with-products__main-banner"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "media-with-products__banner-image",
                    src: _unref(mainBanner).imageUrl,
                    alt: _unref(mainBanner).alt
                  }, null, 8, _hoisted_2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainBanner).overlayClasses, (position) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: position,
                      class: _normalizeClass([`media-with-products__overlay--${position.name}`, 'media-with-products__overlay'])
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            innerHTML: _unref(mainBanner).body,
                            class: _normalizeClass(item)
                          }, null, 10, _hoisted_4))
                        }), 128))
                      ])
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_unref(secondaryBanner))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(secondaryBanner).element), {
                key: 1,
                to: _unref(secondaryBanner).link,
                class: "media-with-products__banner"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "media-with-products__banner-image",
                    src: _unref(secondaryBanner).imageUrl,
                    alt: _unref(secondaryBanner).alt
                  }, null, 8, _hoisted_5),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondaryBanner).overlayClasses, (position) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: position,
                      class: _normalizeClass([`media-with-products__overlay--${position.name}`, 'media-with-products__overlay'])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            innerHTML: _unref(secondaryBanner).body,
                            class: _normalizeClass(item)
                          }, null, 10, _hoisted_7))
                        }), 128))
                      ])
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
          return (_openBlock(), _createBlock(_unref(ProductCard), {
            key: product.articleNumber,
            class: _normalizeClass(["category__product-item", { 'category__product-item--highlight': products.value.length === 1 }]),
            product: product
          }, null, 8, ["class", "product"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})